import { Flex } from "@chakra-ui/react";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { useTranslation } from "react-i18next";
import { isUserPremium } from "../../util/premiumAccess";

export function shouldShowPremiumVerified(user) {
  if (!user) return false;
  if (isUserPremium(user)) return true;
  return user.isVerified === true || user.verified === true;
}

export default function PremiumVerifiedBadge({
  user,
  show,
  size = 18,
  color = "#a8eb34",
}) {
  const { t } = useTranslation();
  const visible = show ?? shouldShowPremiumVerified(user);
  if (!visible) return null;

  return (
    <Flex
      as="span"
      align="center"
      justify="center"
      flexShrink={0}
      title={t("common.premiumVerified")}
      aria-label={t("common.premiumVerified")}
      lineHeight={1}
    >
      <RiVerifiedBadgeFill color={color} size={size} />
    </Flex>
  );
}
